import React from "react";
import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import LookingToBuy from "../components/home/LookingToBuy";
import WhatYouGet from "../components/home/WhatYouGet";
import WhyChoose from "../components/home/WhyChoose";
import PerfectFor from "../components/home/PerfectFor";
import HowItWorks from "../components/home/HowItWorks";
import BookingSection from "../components/home/BookingSection";

export default function Home() {
  return (
    <main>
      <Hero />
      <Stats />
      <LookingToBuy />
      <WhatYouGet />
      <WhyChoose />
      <PerfectFor />
      <HowItWorks />
      <BookingSection />
    </main>
  );
}
